export default "__VITE_ASSET__DHye15tg__"